export const getVisiChatInput = () =>
  document.querySelector('[data-testid="chat-input"]');
